import { useSyncExternalStore } from "react";

import {
  readVisualEffects,
  setVisualEffects,
  subscribeVisualEffects,
} from "./visualEffectsPreference";

function useMediaPreference(query: string) {
  return useSyncExternalStore(
    (listener) => {
      const media = window.matchMedia?.(query);
      media?.addEventListener("change", listener);
      return () => media?.removeEventListener("change", listener);
    },
    () =>
      typeof window !== "undefined" &&
      Boolean(window.matchMedia?.(query).matches),
    () => false,
  );
}

export function useVisualEffects() {
  const level = useSyncExternalStore(
    subscribeVisualEffects,
    readVisualEffects,
    () => "standard" as const,
  );
  const reducedMotion = useMediaPreference("(prefers-reduced-motion: reduce)");
  const reducedTransparency = useMediaPreference(
    "(prefers-reduced-transparency: reduce)",
  );
  const increasedContrast = useMediaPreference("(prefers-contrast: more)");
  return {
    level,
    setLevel: setVisualEffects,
    reducedMotion,
    reducedTransparency: reducedTransparency || increasedContrast,
  };
}
